import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from 'utils/http-client';
import { handleError } from '../../../utils/utils';
import { editStudentFail, editStudentSuccess } from '../action';
import studentActionTypes from '../types';

export function* editStudent({ payload }) {
  const { data, callback } = payload;
  try {
    const response = yield httpClient.put('/students', data);
    yield put(editStudentSuccess(response.data));
    Notify('Student Edited successfully', { position: 'top-right' });
    if (callback) {
      yield callback();
    }
  } catch (error) {
    yield put(editStudentFail(error?.message));
    const err = handleError(error);
  }
}

export function* onEditStudentStart() {
  yield takeLatest(studentActionTypes.EDIT_STUDENT_START, editStudent);
}
